<template>
    <div class="news-wrapper">
        <Head :title="$tc('header.back')"/>
        <news-detail :detaildata="detailData"></news-detail>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import NewsDetail from '@/components/NewsDetail.vue'

import { mapMutations } from 'vuex'

export default {
    name: 'News',
    data () {
        return {
            id: '',
            expireSign: '',
            detailData: null,
            emptydata: null
        }
    },
    components: {
        NewsDetail
    },
    created () {
        this.id = this.$route.params.id
        this.expireSign = this.$route.query.expireSign
        this.getDate()
    },
    beforeRouteLeave (to, form, next) {
        this.$Common.track('unload', {
            name: this.detailData && this.detailData.title,
            id: this.id,
            type: '资讯'
        }).then(() => {
            next()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getDate () {
            this.$Api.getLiveDetail({
                liveId: this.id,
                expireSign: this.expireSign
            }).then(data => {
                if (data) {
                    data.item && (this.detailData = data.item)
                    data.share && this.share(data.share)
                    data.item && this.$Common.track('load', {
                        title: data.item.title,
                        id: this.id,
                        type: '资讯'
                    })
                } else {
                    this.emptydata = {
                        type: 'nodata'
                    }
                }
                this.setShowLoading(false)

                if (data.item.videoLabelRelateList && data.item.videoLabelRelateList[0]) {
                    data.item.videoAiLabels = data.item.videoLabelRelateList[0].labelRelateList.filter(item => item.labelId != -1)
                }
            }).catch((err) => {
                if (err === 404) {
                    this.emptydata = {
                        type: 'nodata'
                    }
                } else {
                    this.emptydata = {
                        type: 'nonetwork'
                    }
                }
                this.setShowLoading(false)
            })
        },
        share (obj) {
            this.$nextTick(() => {
                this.$Common.onshare(obj)
            })
        }
    }
}
</script>
